import { useQuery } from "@tanstack/react-query";
import { UnknownArrivalService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { IssueStatus } from "src/types";

export const useUnknownArrival = (
  warehouseCheckInId: string,
  unknownArrivalService: UnknownArrivalService,
  unknownArrivalStatus?: IssueStatus
) => {
  const {
    data: unknownArrival,
    error: fetchError,
    isLoading,
    refetch,
    isRefetching
  } = useQuery({
    queryKey: queryKeys.unknownArrival(warehouseCheckInId, unknownArrivalStatus),
    queryFn: async () => {
      try {
        return await unknownArrivalService.getWarehouseCheckInUnknownArrival(warehouseCheckInId, unknownArrivalStatus);
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!warehouseCheckInId,
    retry: false
  });

  return { unknownArrival, fetchError, isLoading, refetch, isRefetching };
};
